import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import browserDetect from 'vue-browser-detect-plugin'
import VueMeta from 'vue-meta'
import axios from 'axios'

Vue.use(VueMeta)
Vue.config.productionTip = false
Vue.use(browserDetect)

const LOGIN_ROUTE = '/iniciar-sesion'
const ANSWERS_ENDPOINTS = [
  '/api/questionsMobil',
  '/api/questionsCheco',
  '/api/questionsMax',
  '/api/predicciones'
]

const isAnswersEndpoint = (url = '') => ANSWERS_ENDPOINTS.some(endpoint => url.includes(endpoint))

// Interceptor global: adjunta el token de autenticación a todas las peticiones
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Si el token expiró/no existe en endpoints de respuestas, limpia sesión y redirige a login
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error && error.response ? error.response.status : undefined
    const requestUrl = error && error.config && error.config.url ? error.config.url : ''

    if (status === 401 && isAnswersEndpoint(requestUrl)) {
      localStorage.removeItem('auth_token')
      localStorage.removeItem('predictor')
      if (router.currentRoute.path !== LOGIN_ROUTE) {
        router.push(LOGIN_ROUTE).catch(() => {})
      }
    }

    return Promise.reject(error)
  }
)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
